export const higherPricingArea = [
  {
    zipcode: '06604',
    market: 'New York City',
  },
  {
    zipcode: '06876',
    market: 'New York City',
  },
  {
    zipcode: '07055',
    market: 'New York City',
  },
  {
    zipcode: '07069',
    market: 'New York City',
  },
  {
    zipcode: '07106',
    market: 'New York City',
  },
  {
    zipcode: '07111',
    market: 'New York City',
  },
  {
    zipcode: '06606',
    market: 'New York City',
  },
  {
    zipcode: '06820',
    market: 'New York City',
  },
  {
    zipcode: '06926',
    market: 'New York City',
  },
  {
    zipcode: '07005',
    market: 'New York City',
  },
  {
    zipcode: '07075',
    market: 'New York City',
  },
  {
    zipcode: '07083',
    market: 'New York City',
  },
  {
    zipcode: '07108',
    market: 'New York City',
  },
  {
    zipcode: '07306',
    market: 'New York City',
  },
  {
    zipcode: '07442',
    market: 'New York City',
  },
  {
    zipcode: '07477',
    market: 'New York City',
  },
  {
    zipcode: '07522',
    market: 'New York City',
  },
  {
    zipcode: '07606',
    market: 'New York City',
  },
  {
    zipcode: '07806',
    market: 'New York City',
  },
  {
    zipcode: '07920',
    market: 'New York City',
  },
  {
    zipcode: '08823',
    market: 'New York City',
  },
  {
    zipcode: '08858',
    market: 'New York City',
  },
  {
    zipcode: '08880',
    market: 'New York City',
  },
  {
    zipcode: '08989',
    market: 'New York City',
  },
  {
    zipcode: '07657',
    market: 'New York City',
  },
  {
    zipcode: '07820',
    market: 'New York City',
  },
  {
    zipcode: '07856',
    market: 'New York City',
  },
  {
    zipcode: '08832',
    market: 'New York City',
  },
  {
    zipcode: '06460',
    market: 'New York City',
  },
  {
    zipcode: '06605',
    market: 'New York City',
  },
  {
    zipcode: '07036',
    market: 'New York City',
  },
  {
    zipcode: '06490',
    market: 'New York City',
  },
  {
    zipcode: '06824',
    market: 'New York City',
  },
  {
    zipcode: '07012',
    market: 'New York City',
  },
  {
    zipcode: '07068',
    market: 'New York City',
  },
  {
    zipcode: '07094',
    market: 'New York City',
  },
  {
    zipcode: '07504',
    market: 'New York City',
  },
  {
    zipcode: '07524',
    market: 'New York City',
  },
  {
    zipcode: '07643',
    market: 'New York City',
  },
  {
    zipcode: '07699',
    market: 'New York City',
  },
  {
    zipcode: '07874',
    market: 'New York City',
  },
  {
    zipcode: '08807',
    market: 'New York City',
  },
  {
    zipcode: '07444',
    market: 'New York City',
  },
  {
    zipcode: '07502',
    market: 'New York City',
  },
  {
    zipcode: '07640',
    market: 'New York City',
  },
  {
    zipcode: '07666',
    market: 'New York City',
  },
  {
    zipcode: '07871',
    market: 'New York City',
  },
  {
    zipcode: '07901',
    market: 'New York City',
  },
  {
    zipcode: '07939',
    market: 'New York City',
  },
  {
    zipcode: '07981',
    market: 'New York City',
  },
  {
    zipcode: '08873',
    market: 'New York City',
  },
  {
    zipcode: '08903',
    market: 'New York City',
  },
  {
    zipcode: 10102,
    market: 'New York City',
  },
  {
    zipcode: 10304,
    market: 'New York City',
  },
  {
    zipcode: 10605,
    market: 'New York City',
  },
  {
    zipcode: 11238,
    market: 'New York City',
  },
  {
    zipcode: 11436,
    market: 'New York City',
  },
  {
    zipcode: 11560,
    market: 'New York City',
  },
  {
    zipcode: 11725,
    market: 'New York City',
  },
  {
    zipcode: 11803,
    market: 'New York City',
  },
  {
    zipcode: 10007,
    market: 'New York City',
  },
  {
    zipcode: 10026,
    market: 'New York City',
  },
  {
    zipcode: 10065,
    market: 'New York City',
  },
  {
    zipcode: 11102,
    market: 'New York City',
  },
  {
    zipcode: 11359,
    market: 'New York City',
  },
  {
    zipcode: 11432,
    market: 'New York City',
  },
  {
    zipcode: 11548,
    market: 'New York City',
  },
  {
    zipcode: 11720,
    market: 'New York City',
  },
  {
    zipcode: 11762,
    market: 'New York City',
  },
  {
    zipcode: 11789,
    market: 'New York City',
  },
  {
    zipcode: 10177,
    market: 'New York City',
  },
  {
    zipcode: 10265,
    market: 'New York City',
  },
  {
    zipcode: 10604,
    market: 'New York City',
  },
  {
    zipcode: 11216,
    market: 'New York City',
  },
  {
    zipcode: 10270,
    market: 'New York City',
  },
  {
    zipcode: 10705,
    market: 'New York City',
  },
  {
    zipcode: 10989,
    market: 'New York City',
  },
  {
    zipcode: 11224,
    market: 'New York City',
  },
  {
    zipcode: 11358,
    market: 'New York City',
  },
  {
    zipcode: 11431,
    market: 'New York City',
  },
  {
    zipcode: 11419,
    market: 'New York City',
  },
  {
    zipcode: 11719,
    market: 'New York City',
  },
  {
    zipcode: 11755,
    market: 'New York City',
  },
  {
    zipcode: 11802,
    market: 'New York City',
  },
  {
    zipcode: 11955,
    market: 'New York City',
  },
  {
    zipcode: 11724,
    market: 'New York City',
  },
  {
    zipcode: '06615',
    market: 'New York City',
  },
  {
    zipcode: '06836',
    market: 'New York City',
  },
  {
    zipcode: '07046',
    market: 'New York City',
  },
  {
    zipcode: '07195',
    market: 'New York City',
  },
  {
    zipcode: '07543',
    market: 'New York City',
  },
  {
    zipcode: '07620',
    market: 'New York City',
  },
  {
    zipcode: '07662',
    market: 'New York City',
  },
  {
    zipcode: '07463',
    market: 'New York City',
  },
  {
    zipcode: '07510',
    market: 'New York City',
  },
  {
    zipcode: '07648',
    market: 'New York City',
  },
  {
    zipcode: '07734',
    market: 'New York City',
  },
  {
    zipcode: '07845',
    market: 'New York City',
  },
  {
    zipcode: '06614',
    market: 'New York City',
  },
  {
    zipcode: '07801',
    market: 'New York City',
  },
  {
    zipcode: '08836',
    market: 'New York City',
  },
  {
    zipcode: '08844',
    market: 'New York City',
  },
  {
    zipcode: '08899',
    market: 'New York City',
  },
  {
    zipcode: '07946',
    market: 'New York City',
  },
  {
    zipcode: '07960',
    market: 'New York City',
  },
  {
    zipcode: '07936',
    market: 'New York City',
  },
  {
    zipcode: '08817',
    market: 'New York City',
  },
  {
    zipcode: '08869',
    market: 'New York City',
  },
  {
    zipcode: '07045',
    market: 'New York City',
  },
  {
    zipcode: '07086',
    market: 'New York City',
  },
  {
    zipcode: '07102',
    market: 'New York City',
  },
  {
    zipcode: '07399',
    market: 'New York City',
  },
  {
    zipcode: '07438',
    market: 'New York City',
  },
  {
    zipcode: '07927',
    market: 'New York City',
  },
  {
    zipcode: '08801',
    market: 'New York City',
  },
  {
    zipcode: '08820',
    market: 'New York City',
  },
  {
    zipcode: '06466',
    market: 'New York City',
  },
  {
    zipcode: '07040',
    market: 'New York City',
  },
  {
    zipcode: '07192',
    market: 'New York City',
  },
  {
    zipcode: '07436',
    market: 'New York City',
  },
  {
    zipcode: '07460',
    market: 'New York City',
  },
  {
    zipcode: '07533',
    market: 'New York City',
  },
  {
    zipcode: '07963',
    market: 'New York City',
  },
  {
    zipcode: 10001,
    market: 'New York City',
  },
  {
    zipcode: 10081,
    market: 'New York City',
  },
  {
    zipcode: 11052,
    market: 'New York City',
  },
  {
    zipcode: 11563,
    market: 'New York City',
  },
  {
    zipcode: 11718,
    market: 'New York City',
  },
  {
    zipcode: 11940,
    market: 'New York City',
  },
  {
    zipcode: 10005,
    market: 'New York City',
  },
  {
    zipcode: 10035,
    market: 'New York City',
  },
  {
    zipcode: 10104,
    market: 'New York City',
  },
  {
    zipcode: 10302,
    market: 'New York City',
  },
  {
    zipcode: 10704,
    market: 'New York City',
  },
  {
    zipcode: 10976,
    market: 'New York City',
  },
  {
    zipcode: 11373,
    market: 'New York City',
  },
  {
    zipcode: 11520,
    market: 'New York City',
  },
  {
    zipcode: 11569,
    market: 'New York City',
  },
  {
    zipcode: 11727,
    market: 'New York City',
  },
  {
    zipcode: 10159,
    market: 'New York City',
  },
  {
    zipcode: 10179,
    market: 'New York City',
  },
  {
    zipcode: 10272,
    market: 'New York City',
  },
  {
    zipcode: 10462,
    market: 'New York City',
  },
  {
    zipcode: 11210,
    market: 'New York City',
  },
  {
    zipcode: 11245,
    market: 'New York City',
  },
  {
    zipcode: 11364,
    market: 'New York City',
  },
  {
    zipcode: 11702,
    market: 'New York City',
  },
  {
    zipcode: 11786,
    market: 'New York City',
  },
  {
    zipcode: 10011,
    market: 'New York City',
  },
  {
    zipcode: 10034,
    market: 'New York City',
  },
  {
    zipcode: 10203,
    market: 'New York City',
  },
  {
    zipcode: 10545,
    market: 'New York City',
  },
  {
    zipcode: 10911,
    market: 'New York City',
  },
  {
    zipcode: 11022,
    market: 'New York City',
  },
  {
    zipcode: 11214,
    market: 'New York City',
  },
  {
    zipcode: 11252,
    market: 'New York City',
  },
  {
    zipcode: 11368,
    market: 'New York City',
  },
  {
    zipcode: 11706,
    market: 'New York City',
  },
  {
    zipcode: 11767,
    market: 'New York City',
  },
  {
    zipcode: '06904',
    market: 'New York City',
  },
  {
    zipcode: '08875',
    market: 'New York City',
  },
  {
    zipcode: 10548,
    market: 'New York City',
  },
  {
    zipcode: 11054,
    market: 'New York City',
  },
  {
    zipcode: 11217,
    market: 'New York City',
  },
  {
    zipcode: 11386,
    market: 'New York City',
  },
  {
    zipcode: 11424,
    market: 'New York City',
  },
  {
    zipcode: 11556,
    market: 'New York City',
  },
  {
    zipcode: 11693,
    market: 'New York City',
  },
  {
    zipcode: 11716,
    market: 'New York City',
  },
  {
    zipcode: 11797,
    market: 'New York City',
  },
  {
    zipcode: 11215,
    market: 'New York City',
  },
  {
    zipcode: 10040,
    market: 'New York City',
  },
  {
    zipcode: 10113,
    market: 'New York City',
  },
  {
    zipcode: 10162,
    market: 'New York City',
  },
  {
    zipcode: 10268,
    market: 'New York City',
  },
  {
    zipcode: 10308,
    market: 'New York City',
  },
  {
    zipcode: 11213,
    market: 'New York City',
  },
  {
    zipcode: 11375,
    market: 'New York City',
  },
  {
    zipcode: 11420,
    market: 'New York City',
  },
  {
    zipcode: 11552,
    market: 'New York City',
  },
  {
    zipcode: 10006,
    market: 'New York City',
  },
  {
    zipcode: 10161,
    market: 'New York City',
  },
  {
    zipcode: 10303,
    market: 'New York City',
  },
  {
    zipcode: 10523,
    market: 'New York City',
  },
  {
    zipcode: 10701,
    market: 'New York City',
  },
  {
    zipcode: 10803,
    market: 'New York City',
  },
  {
    zipcode: 10002,
    market: 'New York City',
  },
  {
    zipcode: 10123,
    market: 'New York City',
  },
  {
    zipcode: 10281,
    market: 'New York City',
  },
  {
    zipcode: 11208,
    market: 'New York City',
  },
  {
    zipcode: 11423,
    market: 'New York City',
  },
  {
    zipcode: 11547,
    market: 'New York City',
  },
  {
    zipcode: 11581,
    market: 'New York City',
  },
  {
    zipcode: 11101,
    market: 'New York City',
  },
  {
    zipcode: 11516,
    market: 'New York City',
  },
  {
    zipcode: 11733,
    market: 'New York City',
  },
  {
    zipcode: 11769,
    market: 'New York City',
  },
  {
    zipcode: '07019',
    market: 'New York City',
  },
  {
    zipcode: '07054',
    market: 'New York City',
  },
  {
    zipcode: '07851',
    market: 'New York City',
  },
  {
    zipcode: '07507',
    market: 'New York City',
  },
  {
    zipcode: '07043',
    market: 'New York City',
  },
  {
    zipcode: '06673',
    market: 'New York City',
  },
  {
    zipcode: '07417',
    market: 'New York City',
  },
  {
    zipcode: '07922',
    market: 'New York City',
  },
  {
    zipcode: '08830',
    market: 'New York City',
  },
  {
    zipcode: '08835',
    market: 'New York City',
  },
  {
    zipcode: '06880',
    market: 'New York City',
  },
  {
    zipcode: '07022',
    market: 'New York City',
  },
  {
    zipcode: '07072',
    market: 'New York City',
  },
  {
    zipcode: '07199',
    market: 'New York City',
  },
  {
    zipcode: '07310',
    market: 'New York City',
  },
  {
    zipcode: '07450',
    market: 'New York City',
  },
  {
    zipcode: '07501',
    market: 'New York City',
  },
  {
    zipcode: '07847',
    market: 'New York City',
  },
  {
    zipcode: '08850',
    market: 'New York City',
  },
  {
    zipcode: '08988',
    market: 'New York City',
  },
  {
    zipcode: '06431',
    market: 'New York City',
  },
  {
    zipcode: '06612',
    market: 'New York City',
  },
  {
    zipcode: '06831',
    market: 'New York City',
  },
  {
    zipcode: '07107',
    market: 'New York City',
  },
  {
    zipcode: '07308',
    market: 'New York City',
  },
  {
    zipcode: '06851',
    market: 'New York City',
  },
  {
    zipcode: '07002',
    market: 'New York City',
  },
  {
    zipcode: '07014',
    market: 'New York City',
  },
  {
    zipcode: '07033',
    market: 'New York City',
  },
  {
    zipcode: '07081',
    market: 'New York City',
  },
  {
    zipcode: '07302',
    market: 'New York City',
  },
  {
    zipcode: '07390',
    market: 'New York City',
  },
  {
    zipcode: '07439',
    market: 'New York City',
  },
  {
    zipcode: '07470',
    market: 'New York City',
  },
  {
    zipcode: '07015',
    market: 'New York City',
  },
  {
    zipcode: '07035',
    market: 'New York City',
  },
  {
    zipcode: '07057',
    market: 'New York City',
  },
  {
    zipcode: '07182',
    market: 'New York City',
  },
  {
    zipcode: '07405',
    market: 'New York City',
  },
  {
    zipcode: '07645',
    market: 'New York City',
  },
  {
    zipcode: '07848',
    market: 'New York City',
  },
  {
    zipcode: '07866',
    market: 'New York City',
  },
  {
    zipcode: '07977',
    market: 'New York City',
  },
  {
    zipcode: 0,
    market: 'New York City',
  },
  {
    zipcode: '07538',
    market: 'New York City',
  },
  {
    zipcode: '07627',
    market: 'New York City',
  },
  {
    zipcode: '07870',
    market: 'New York City',
  },
  {
    zipcode: '07928',
    market: 'New York City',
  },
  {
    zipcode: '08862',
    market: 'New York City',
  },
  {
    zipcode: '08882',
    market: 'New York City',
  },
  {
    zipcode: '06842',
    market: 'New York City',
  },
  {
    zipcode: '06906',
    market: 'New York City',
  },
  {
    zipcode: '07004',
    market: 'New York City',
  },
  {
    zipcode: '07021',
    market: 'New York City',
  },
  {
    zipcode: '06878',
    market: 'New York City',
  },
  {
    zipcode: '06905',
    market: 'New York City',
  },
  {
    zipcode: '07003',
    market: 'New York City',
  },
  {
    zipcode: '07031',
    market: 'New York City',
  },
  {
    zipcode: '07078',
    market: 'New York City',
  },
  {
    zipcode: '07307',
    market: 'New York City',
  },
  {
    zipcode: '07422',
    market: 'New York City',
  },
  {
    zipcode: '07451',
    market: 'New York City',
  },
  {
    zipcode: '07902',
    market: 'New York City',
  },
  {
    zipcode: '07940',
    market: 'New York City',
  },
  {
    zipcode: '07999',
    market: 'New York City',
  },
  {
    zipcode: '08861',
    market: 'New York City',
  },
  {
    zipcode: '08876',
    market: 'New York City',
  },
  {
    zipcode: '07063',
    market: 'New York City',
  },
  {
    zipcode: '07076',
    market: 'New York City',
  },
  {
    zipcode: '07092',
    market: 'New York City',
  },
  {
    zipcode: '07216',
    market: 'New York City',
  },
  {
    zipcode: '07421',
    market: 'New York City',
  },
  {
    zipcode: '07513',
    market: 'New York City',
  },
  {
    zipcode: '07802',
    market: 'New York City',
  },
  {
    zipcode: '07830',
    market: 'New York City',
  },
  {
    zipcode: '07842',
    market: 'New York City',
  },
  {
    zipcode: '08859',
    market: 'New York City',
  },
  {
    zipcode: '08904',
    market: 'New York City',
  },
  {
    zipcode: 11949,
    market: 'New York City',
  },
  {
    zipcode: 10010,
    market: 'New York City',
  },
  {
    zipcode: 11967,
    market: 'New York City',
  },
  {
    zipcode: 10923,
    market: 'New York City',
  },
  {
    zipcode: 10154,
    market: 'New York City',
  },
  {
    zipcode: 10249,
    market: 'New York City',
  },
  {
    zipcode: 10562,
    market: 'New York City',
  },
  {
    zipcode: 11363,
    market: 'New York City',
  },
  {
    zipcode: 11770,
    market: 'New York City',
  },
  {
    zipcode: 10150,
    market: 'New York City',
  },
  {
    zipcode: 10178,
    market: 'New York City',
  },
  {
    zipcode: 10461,
    market: 'New York City',
  },
  {
    zipcode: 10804,
    market: 'New York City',
  },
  {
    zipcode: 11221,
    market: 'New York City',
  },
  {
    zipcode: 10044,
    market: 'New York City',
  },
  {
    zipcode: 10101,
    market: 'New York City',
  },
  {
    zipcode: 10460,
    market: 'New York City',
  },
  {
    zipcode: 11024,
    market: 'New York City',
  },
  {
    zipcode: 11105,
    market: 'New York City',
  },
  {
    zipcode: 10060,
    market: 'New York City',
  },
  {
    zipcode: 10105,
    market: 'New York City',
  },
  {
    zipcode: 10199,
    market: 'New York City',
  },
  {
    zipcode: 10528,
    market: 'New York City',
  },
  {
    zipcode: 11030,
    market: 'New York City',
  },
  {
    zipcode: 11120,
    market: 'New York City',
  },
  {
    zipcode: 11379,
    market: 'New York City',
  },
  {
    zipcode: 11551,
    market: 'New York City',
  },
  {
    zipcode: 11370,
    market: 'New York City',
  },
  {
    zipcode: 11530,
    market: 'New York City',
  },
  {
    zipcode: 11692,
    market: 'New York City',
  },
  {
    zipcode: 11697,
    market: 'New York City',
  },
  {
    zipcode: 11765,
    market: 'New York City',
  },
  {
    zipcode: '00544',
    market: 'New York City',
  },
  {
    zipcode: '06922',
    market: 'New York City',
  },
  {
    zipcode: '07030',
    market: 'New York City',
  },
  {
    zipcode: '07062',
    market: 'New York City',
  },
  {
    zipcode: '07631',
    market: 'New York City',
  },
  {
    zipcode: '07836',
    market: 'New York City',
  },
  {
    zipcode: '07198',
    market: 'New York City',
  },
  {
    zipcode: '07018',
    market: 'New York City',
  },
  {
    zipcode: '07088',
    market: 'New York City',
  },
  {
    zipcode: '07184',
    market: 'New York City',
  },
  {
    zipcode: '07305',
    market: 'New York City',
  },
  {
    zipcode: '07428',
    market: 'New York City',
  },
  {
    zipcode: '07607',
    market: 'New York City',
  },
  {
    zipcode: '07826',
    market: 'New York City',
  },
  {
    zipcode: '07041',
    market: 'New York City',
  },
  {
    zipcode: '07945',
    market: 'New York City',
  },
  {
    zipcode: '06828',
    market: 'New York City',
  },
  {
    zipcode: '07498',
    market: 'New York City',
  },
  {
    zipcode: '07602',
    market: 'New York City',
  },
  {
    zipcode: '07646',
    market: 'New York City',
  },
  {
    zipcode: '08840',
    market: 'New York City',
  },
  {
    zipcode: '08905',
    market: 'New York City',
  },
  {
    zipcode: '06855',
    market: 'New York City',
  },
  {
    zipcode: '06910',
    market: 'New York City',
  },
  {
    zipcode: '07059',
    market: 'New York City',
  },
  {
    zipcode: '07101',
    market: 'New York City',
  },
  {
    zipcode: '07395',
    market: 'New York City',
  },
  {
    zipcode: '07624',
    market: 'New York City',
  },
  {
    zipcode: '07849',
    market: 'New York City',
  },
  {
    zipcode: 10031,
    market: 'New York City',
  },
  {
    zipcode: 10176,
    market: 'New York City',
  },
  {
    zipcode: 10277,
    market: 'New York City',
  },
  {
    zipcode: 10463,
    market: 'New York City',
  },
  {
    zipcode: 10607,
    market: 'New York City',
  },
  {
    zipcode: 11236,
    market: 'New York City',
  },
  {
    zipcode: 11369,
    market: 'New York City',
  },
  {
    zipcode: 11434,
    market: 'New York City',
  },
  {
    zipcode: 11691,
    market: 'New York City',
  },
  {
    zipcode: 11768,
    market: 'New York City',
  },
  {
    zipcode: 11791,
    market: 'New York City',
  },
  {
    zipcode: 10258,
    market: 'New York City',
  },
  {
    zipcode: 10467,
    market: 'New York City',
  },
  {
    zipcode: 10576,
    market: 'New York City',
  },
  {
    zipcode: 11211,
    market: 'New York City',
  },
  {
    zipcode: 11241,
    market: 'New York City',
  },
  {
    zipcode: 11703,
    market: 'New York City',
  },
  {
    zipcode: 11772,
    market: 'New York City',
  },
  {
    zipcode: 11801,
    market: 'New York City',
  },
  {
    zipcode: 10004,
    market: 'New York City',
  },
  {
    zipcode: 10027,
    market: 'New York City',
  },
  {
    zipcode: 10573,
    market: 'New York City',
  },
  {
    zipcode: 10801,
    market: 'New York City',
  },
  {
    zipcode: 10975,
    market: 'New York City',
  },
  {
    zipcode: 11010,
    market: 'New York City',
  },
  {
    zipcode: 11055,
    market: 'New York City',
  },
  {
    zipcode: 11421,
    market: 'New York City',
  },
  {
    zipcode: 11501,
    market: 'New York City',
  },
  {
    zipcode: 11741,
    market: 'New York City',
  },
  {
    zipcode: 11933,
    market: 'New York City',
  },
  {
    zipcode: 10163,
    market: 'New York City',
  },
  {
    zipcode: 10312,
    market: 'New York City',
  },
  {
    zipcode: 10466,
    market: 'New York City',
  },
  {
    zipcode: 10983,
    market: 'New York City',
  },
  {
    zipcode: 11103,
    market: 'New York City',
  },
  {
    zipcode: 11429,
    market: 'New York City',
  },
  {
    zipcode: 11553,
    market: 'New York City',
  },
  {
    zipcode: 11790,
    market: 'New York City',
  },
  {
    zipcode: '06461',
    market: 'New York City',
  },
  {
    zipcode: '06920',
    market: 'New York City',
  },
  {
    zipcode: 10120,
    market: 'New York City',
  },
  {
    zipcode: 10166,
    market: 'New York City',
  },
  {
    zipcode: 10275,
    market: 'New York City',
  },
  {
    zipcode: 10465,
    market: 'New York City',
  },
  {
    zipcode: 10601,
    market: 'New York City',
  },
  {
    zipcode: 11002,
    market: 'New York City',
  },
  {
    zipcode: 11243,
    market: 'New York City',
  },
  {
    zipcode: 11752,
    market: 'New York City',
  },
  {
    zipcode: 11960,
    market: 'New York City',
  },
  {
    zipcode: 11758,
    market: 'New York City',
  },
  {
    zipcode: 10457,
    market: 'New York City',
  },
  {
    zipcode: 10543,
    market: 'New York City',
  },
  {
    zipcode: 10596,
    market: 'New York City',
  },
  {
    zipcode: 10959,
    market: 'New York City',
  },
  {
    zipcode: 11234,
    market: 'New York City',
  },
  {
    zipcode: 11599,
    market: 'New York City',
  },
  {
    zipcode: 11710,
    market: 'New York City',
  },
  {
    zipcode: 11746,
    market: 'New York City',
  },
  {
    zipcode: 11793,
    market: 'New York City',
  },
  {
    zipcode: 10025,
    market: 'New York City',
  },
  {
    zipcode: 10128,
    market: 'New York City',
  },
  {
    zipcode: 10259,
    market: 'New York City',
  },
  {
    zipcode: 10464,
    market: 'New York City',
  },
  {
    zipcode: 10968,
    market: 'New York City',
  },
  {
    zipcode: 10994,
    market: 'New York City',
  },
  {
    zipcode: 10021,
    market: 'New York City',
  },
  {
    zipcode: 10036,
    market: 'New York City',
  },
  {
    zipcode: 10157,
    market: 'New York City',
  },
  {
    zipcode: 10173,
    market: 'New York City',
  },
  {
    zipcode: 10456,
    market: 'New York City',
  },
  {
    zipcode: 10920,
    market: 'New York City',
  },
  {
    zipcode: 10962,
    market: 'New York City',
  },
  {
    zipcode: 11242,
    market: 'New York City',
  },
  {
    zipcode: 11743,
    market: 'New York City',
  },
  {
    zipcode: 11773,
    market: 'New York City',
  },
  {
    zipcode: 11819,
    market: 'New York City',
  },
  {
    zipcode: 11972,
    market: 'New York City',
  },
  {
    zipcode: 11237,
    market: 'New York City',
  },
  {
    zipcode: 11385,
    market: 'New York City',
  },
  {
    zipcode: 11576,
    market: 'New York City',
  },
  {
    zipcode: 11792,
    market: 'New York City',
  },
  {
    zipcode: '07099',
    market: 'New York City',
  },
  {
    zipcode: '07188',
    market: 'New York City',
  },
  {
    zipcode: '07311',
    market: 'New York City',
  },
  {
    zipcode: '07837',
    market: 'New York City',
  },
  {
    zipcode: '07204',
    market: 'New York City',
  },
  {
    zipcode: '07675',
    market: 'New York City',
  },
  {
    zipcode: '07020',
    market: 'New York City',
  },
  {
    zipcode: '07097',
    market: 'New York City',
  },
  {
    zipcode: '07509',
    market: 'New York City',
  },
  {
    zipcode: '07065',
    market: 'New York City',
  },
  {
    zipcode: '07839',
    market: 'New York City',
  },
  {
    zipcode: '07970',
    market: 'New York City',
  },
  {
    zipcode: '07978',
    market: 'New York City',
  },
  {
    zipcode: '08879',
    market: 'New York City',
  },
  {
    zipcode: '07979',
    market: 'New York City',
  },
  {
    zipcode: '08890',
    market: 'New York City',
  },
  {
    zipcode: '08854',
    market: 'New York City',
  },
  {
    zipcode: '06807',
    market: 'New York City',
  },
  {
    zipcode: '07114',
    market: 'New York City',
  },
  {
    zipcode: '07207',
    market: 'New York City',
  },
  {
    zipcode: '07608',
    market: 'New York City',
  },
  {
    zipcode: '07875',
    market: 'New York City',
  },
  {
    zipcode: '08818',
    market: 'New York City',
  },
  {
    zipcode: '08877',
    market: 'New York City',
  },
  {
    zipcode: '06858',
    market: 'New York City',
  },
  {
    zipcode: '07071',
    market: 'New York City',
  },
  {
    zipcode: '07194',
    market: 'New York City',
  },
  {
    zipcode: '07206',
    market: 'New York City',
  },
  {
    zipcode: '07423',
    market: 'New York City',
  },
  {
    zipcode: '07514',
    market: 'New York City',
  },
  {
    zipcode: '07663',
    market: 'New York City',
  },
  {
    zipcode: '08871',
    market: 'New York City',
  },
  {
    zipcode: 10009,
    market: 'New York City',
  },
  {
    zipcode: 10152,
    market: 'New York City',
  },
  {
    zipcode: 10172,
    market: 'New York City',
  },
  {
    zipcode: 10286,
    market: 'New York City',
  },
  {
    zipcode: 10475,
    market: 'New York City',
  },
  {
    zipcode: 10546,
    market: 'New York City',
  },
  {
    zipcode: 10912,
    market: 'New York City',
  },
  {
    zipcode: 11104,
    market: 'New York City',
  },
  {
    zipcode: 11357,
    market: 'New York City',
  },
  {
    zipcode: 11405,
    market: 'New York City',
  },
  {
    zipcode: 11507,
    market: 'New York City',
  },
  {
    zipcode: 10028,
    market: 'New York City',
  },
  {
    zipcode: 10119,
    market: 'New York City',
  },
  {
    zipcode: 10168,
    market: 'New York City',
  },
  {
    zipcode: 10459,
    market: 'New York City',
  },
  {
    zipcode: 10580,
    market: 'New York City',
  },
  {
    zipcode: 10965,
    market: 'New York City',
  },
  {
    zipcode: 11430,
    market: 'New York City',
  },
  {
    zipcode: 10038,
    market: 'New York City',
  },
  {
    zipcode: 10090,
    market: 'New York City',
  },
  {
    zipcode: 10114,
    market: 'New York City',
  },
  {
    zipcode: 10305,
    market: 'New York City',
  },
  {
    zipcode: 10502,
    market: 'New York City',
  },
  {
    zipcode: 10530,
    market: 'New York City',
  },
  {
    zipcode: 11235,
    market: 'New York City',
  },
  {
    zipcode: 11721,
    market: 'New York City',
  },
  {
    zipcode: 11753,
    market: 'New York City',
  },
  {
    zipcode: 11798,
    market: 'New York City',
  },
  {
    zipcode: 10133,
    market: 'New York City',
  },
  {
    zipcode: 10213,
    market: 'New York City',
  },
  {
    zipcode: 10301,
    market: 'New York City',
  },
  {
    zipcode: 10474,
    market: 'New York City',
  },
  {
    zipcode: 10553,
    market: 'New York City',
  },
  {
    zipcode: 11572,
    market: 'New York City',
  },
  {
    zipcode: 11780,
    market: 'New York City',
  },
  {
    zipcode: 11980,
    market: 'New York City',
  },
  {
    zipcode: '07677',
    market: 'New York City',
  },
  {
    zipcode: '06838',
    market: 'New York City',
  },
  {
    zipcode: '08870',
    market: 'New York City',
  },
  {
    zipcode: '06830',
    market: 'New York City',
  },
  {
    zipcode: '07006',
    market: 'New York City',
  },
  {
    zipcode: '07016',
    market: 'New York City',
  },
  {
    zipcode: '07042',
    market: 'New York City',
  },
  {
    zipcode: '07060',
    market: 'New York City',
  },
  {
    zipcode: '07077',
    market: 'New York City',
  },
  {
    zipcode: '07109',
    market: 'New York City',
  },
  {
    zipcode: '07416',
    market: 'New York City',
  },
  {
    zipcode: '06602',
    market: 'New York City',
  },
  {
    zipcode: '06870',
    market: 'New York City',
  },
  {
    zipcode: '06907',
    market: 'New York City',
  },
  {
    zipcode: '06921',
    market: 'New York City',
  },
  {
    zipcode: '07026',
    market: 'New York City',
  },
  {
    zipcode: '07051',
    market: 'New York City',
  },
  {
    zipcode: '07066',
    market: 'New York City',
  },
  {
    zipcode: '07103',
    market: 'New York City',
  },
  {
    zipcode: '07419',
    market: 'New York City',
  },
  {
    zipcode: '07601',
    market: 'New York City',
  },
  {
    zipcode: '07544',
    market: 'New York City',
  },
  {
    zipcode: '07641',
    market: 'New York City',
  },
  {
    zipcode: '07857',
    market: 'New York City',
  },
  {
    zipcode: '07877',
    market: 'New York City',
  },
  {
    zipcode: '07644',
    market: 'New York City',
  },
  {
    zipcode: '07688',
    market: 'New York City',
  },
  {
    zipcode: '07890',
    market: 'New York City',
  },
  {
    zipcode: '07974',
    market: 'New York City',
  },
  {
    zipcode: '08902',
    market: 'New York City',
  },
  {
    zipcode: '07027',
    market: 'New York City',
  },
  {
    zipcode: '06897',
    market: 'New York City',
  },
  {
    zipcode: '07039',
    market: 'New York City',
  },
  {
    zipcode: '07061',
    market: 'New York City',
  },
  {
    zipcode: '07074',
    market: 'New York City',
  },
  {
    zipcode: '07082',
    market: 'New York City',
  },
  {
    zipcode: '07189',
    market: 'New York City',
  },
  {
    zipcode: '07418',
    market: 'New York City',
  },
  {
    zipcode: '07721',
    market: 'New York City',
  },
  {
    zipcode: '07931',
    market: 'New York City',
  },
  {
    zipcode: '07980',
    market: 'New York City',
  },
  {
    zipcode: '08872',
    market: 'New York City',
  },
  {
    zipcode: '07058',
    market: 'New York City',
  },
  {
    zipcode: '07080',
    market: 'New York City',
  },
  {
    zipcode: '07430',
    market: 'New York City',
  },
  {
    zipcode: '07653',
    market: 'New York City',
  },
  {
    zipcode: '07878',
    market: 'New York City',
  },
  {
    zipcode: '08812',
    market: 'New York City',
  },
  {
    zipcode: '08833',
    market: 'New York City',
  },
  {
    zipcode: '08896',
    market: 'New York City',
  },
  {
    zipcode: 10045,
    market: 'New York City',
  },
  {
    zipcode: 11714,
    market: 'New York City',
  },
  {
    zipcode: 10129,
    market: 'New York City',
  },
  {
    zipcode: 10982,
    market: 'New York City',
  },
  {
    zipcode: 11571,
    market: 'New York City',
  },
  {
    zipcode: 11756,
    market: 'New York City',
  },
  {
    zipcode: 10117,
    market: 'New York City',
  },
  {
    zipcode: 10158,
    market: 'New York City',
  },
  {
    zipcode: 10311,
    market: 'New York City',
  },
  {
    zipcode: 10520,
    market: 'New York City',
  },
  {
    zipcode: 11021,
    market: 'New York City',
  },
  {
    zipcode: 11201,
    market: 'New York City',
  },
  {
    zipcode: 11371,
    market: 'New York City',
  },
  {
    zipcode: 11853,
    market: 'New York City',
  },
  {
    zipcode: 10307,
    market: 'New York City',
  },
  {
    zipcode: 10577,
    market: 'New York City',
  },
  {
    zipcode: 11005,
    market: 'New York City',
  },
  {
    zipcode: 11204,
    market: 'New York City',
  },
  {
    zipcode: 11411,
    market: 'New York City',
  },
  {
    zipcode: 10087,
    market: 'New York City',
  },
  {
    zipcode: 10242,
    market: 'New York City',
  },
  {
    zipcode: 10514,
    market: 'New York City',
  },
  {
    zipcode: 11212,
    market: 'New York City',
  },
  {
    zipcode: 11509,
    market: 'New York City',
  },
  {
    zipcode: 11451,
    market: 'New York City',
  },
  {
    zipcode: 11565,
    market: 'New York City',
  },
  {
    zipcode: 11709,
    market: 'New York City',
  },
  {
    zipcode: 11941,
    market: 'New York City',
  },
  {
    zipcode: 11570,
    market: 'New York City',
  },
  {
    zipcode: 11715,
    market: 'New York City',
  },
  {
    zipcode: 11739,
    market: 'New York City',
  },
  {
    zipcode: 11951,
    market: 'New York City',
  },
  {
    zipcode: '06890',
    market: 'New York City',
  },
  {
    zipcode: '07112',
    market: 'New York City',
  },
  {
    zipcode: '07511',
    market: 'New York City',
  },
  {
    zipcode: '06889',
    market: 'New York City',
  },
  {
    zipcode: '07446',
    market: 'New York City',
  },
  {
    zipcode: '07067',
    market: 'New York City',
  },
  {
    zipcode: '07632',
    market: 'New York City',
  },
  {
    zipcode: '07803',
    market: 'New York City',
  },
  {
    zipcode: '08829',
    market: 'New York City',
  },
  {
    zipcode: '08889',
    market: 'New York City',
  },
  {
    zipcode: '07921',
    market: 'New York City',
  },
  {
    zipcode: '08855',
    market: 'New York City',
  },
  {
    zipcode: '07930',
    market: 'New York City',
  },
  {
    zipcode: '07934',
    market: 'New York City',
  },
  {
    zipcode: '08863',
    market: 'New York City',
  },
  {
    zipcode: '06607',
    market: 'New York City',
  },
  {
    zipcode: '07032',
    market: 'New York City',
  },
  {
    zipcode: '07050',
    market: 'New York City',
  },
  {
    zipcode: '07205',
    market: 'New York City',
  },
  {
    zipcode: '07621',
    market: 'New York City',
  },
  {
    zipcode: '07676',
    market: 'New York City',
  },
  {
    zipcode: '07735',
    market: 'New York City',
  },
  {
    zipcode: '08878',
    market: 'New York City',
  },
  {
    zipcode: '07023',
    market: 'New York City',
  },
  {
    zipcode: '07105',
    market: 'New York City',
  },
  {
    zipcode: '07197',
    market: 'New York City',
  },
  {
    zipcode: '07424',
    market: 'New York City',
  },
  {
    zipcode: '07605',
    market: 'New York City',
  },
  {
    zipcode: '07933',
    market: 'New York City',
  },
  {
    zipcode: '08570',
    market: 'New York City',
  },
  {
    zipcode: '08822',
    market: 'New York City',
  },
  {
    zipcode: 10455,
    market: 'New York City',
  },
  {
    zipcode: 10603,
    market: 'New York City',
  },
  {
    zipcode: 10984,
    market: 'New York City',
  },
  {
    zipcode: 11232,
    market: 'New York City',
  },
  {
    zipcode: 11361,
    market: 'New York City',
  },
  {
    zipcode: 10012,
    market: 'New York City',
  },
  {
    zipcode: 10043,
    market: 'New York City',
  },
  {
    zipcode: 10313,
    market: 'New York City',
  },
  {
    zipcode: 10471,
    market: 'New York City',
  },
  {
    zipcode: 10522,
    market: 'New York City',
  },
  {
    zipcode: 10802,
    market: 'New York City',
  },
  {
    zipcode: 11023,
    market: 'New York City',
  },
  {
    zipcode: 11219,
    market: 'New York City',
  },
  {
    zipcode: 11414,
    market: 'New York City',
  },
  {
    zipcode: 11550,
    market: 'New York City',
  },
  {
    zipcode: 11742,
    market: 'New York City',
  },
  {
    zipcode: 10023,
    market: 'New York City',
  },
  {
    zipcode: 10454,
    market: 'New York City',
  },
  {
    zipcode: 10506,
    market: 'New York City',
  },
  {
    zipcode: 10710,
    market: 'New York City',
  },
  {
    zipcode: 11202,
    market: 'New York City',
  },
  {
    zipcode: 11239,
    market: 'New York City',
  },
  {
    zipcode: 11377,
    market: 'New York City',
  },
  {
    zipcode: 11439,
    market: 'New York City',
  },
  {
    zipcode: 11961,
    market: 'New York City',
  },
  {
    zipcode: 10016,
    market: 'New York City',
  },
  {
    zipcode: 10118,
    market: 'New York City',
  },
  {
    zipcode: 10171,
    market: 'New York City',
  },
  {
    zipcode: 10602,
    market: 'New York City',
  },
  {
    zipcode: 10964,
    market: 'New York City',
  },
  {
    zipcode: 11027,
    market: 'New York City',
  },
  {
    zipcode: 11222,
    market: 'New York City',
  },
  {
    zipcode: 11351,
    market: 'New York City',
  },
  {
    zipcode: 11372,
    market: 'New York City',
  },
  {
    zipcode: 11433,
    market: 'New York City',
  },
  {
    zipcode: 11561,
    market: 'New York City',
  },
  {
    zipcode: 11794,
    market: 'New York City',
  },
  {
    zipcode: '06912',
    market: 'New York City',
  },
  {
    zipcode: '07961',
    market: 'New York City',
  },
  {
    zipcode: 10212,
    market: 'New York City',
  },
  {
    zipcode: 10282,
    market: 'New York City',
  },
  {
    zipcode: 10453,
    market: 'New York City',
  },
  {
    zipcode: 10473,
    market: 'New York City',
  },
  {
    zipcode: 10590,
    market: 'New York City',
  },
  {
    zipcode: 10702,
    market: 'New York City',
  },
  {
    zipcode: 11026,
    market: 'New York City',
  },
  {
    zipcode: 11367,
    market: 'New York City',
  },
  {
    zipcode: 11518,
    market: 'New York City',
  },
  {
    zipcode: 11705,
    market: 'New York City',
  },
  {
    zipcode: 11735,
    market: 'New York City',
  },
  {
    zipcode: 11779,
    market: 'New York City',
  },
  {
    zipcode: 10022,
    market: 'New York City',
  },
  {
    zipcode: 10106,
    market: 'New York City',
  },
  {
    zipcode: 10170,
    market: 'New York City',
  },
  {
    zipcode: 10279,
    market: 'New York City',
  },
  {
    zipcode: 10552,
    market: 'New York City',
  },
  {
    zipcode: 10610,
    market: 'New York City',
  },
  {
    zipcode: 10974,
    market: 'New York City',
  },
  {
    zipcode: 11106,
    market: 'New York City',
  },
  {
    zipcode: 11225,
    market: 'New York City',
  },
  {
    zipcode: 11251,
    market: 'New York City',
  },
  {
    zipcode: 11701,
    market: 'New York City',
  },
  {
    zipcode: 11730,
    market: 'New York City',
  },
  {
    zipcode: 10153,
    market: 'New York City',
  },
  {
    zipcode: 10452,
    market: 'New York City',
  },
  {
    zipcode: 10472,
    market: 'New York City',
  },
  {
    zipcode: 10029,
    market: 'New York City',
  },
  {
    zipcode: 10112,
    market: 'New York City',
  },
  {
    zipcode: 10274,
    market: 'New York City',
  },
  {
    zipcode: 10952,
    market: 'New York City',
  },
  {
    zipcode: 11435,
    market: 'New York City',
  },
  {
    zipcode: 11704,
    market: 'New York City',
  },
  {
    zipcode: 11760,
    market: 'New York City',
  },
  {
    zipcode: 11788,
    market: 'New York City',
  },
  {
    zipcode: 10977,
    market: 'New York City',
  },
  {
    zipcode: 11001,
    market: 'New York City',
  },
  {
    zipcode: 11220,
    market: 'New York City',
  },
  {
    zipcode: 11751,
    market: 'New York City',
  },
  {
    zipcode: '06825',
    market: 'New York City',
  },
  {
    zipcode: '07034',
    market: 'New York City',
  },
  {
    zipcode: '06927',
    market: 'New York City',
  },
  {
    zipcode: '07009',
    market: 'New York City',
  },
  {
    zipcode: '07403',
    market: 'New York City',
  },
  {
    zipcode: '07512',
    market: 'New York City',
  },
  {
    zipcode: '07481',
    market: 'New York City',
  },
  {
    zipcode: '07652',
    market: 'New York City',
  },
  {
    zipcode: '07087',
    market: 'New York City',
  },
  {
    zipcode: '07201',
    market: 'New York City',
  },
  {
    zipcode: '07603',
    market: 'New York City',
  },
  {
    zipcode: '07093',
    market: 'New York City',
  },
  {
    zipcode: '07462',
    market: 'New York City',
  },
  {
    zipcode: '07649',
    market: 'New York City',
  },
  {
    zipcode: '07661',
    market: 'New York City',
  },
  {
    zipcode: '07840',
    market: 'New York City',
  },
  {
    zipcode: '08837',
    market: 'New York City',
  },
  {
    zipcode: '06430',
    market: 'New York City',
  },
  {
    zipcode: '06850',
    market: 'New York City',
  },
  {
    zipcode: '07017',
    market: 'New York City',
  },
  {
    zipcode: '07650',
    market: 'New York City',
  },
  {
    zipcode: '07852',
    market: 'New York City',
  },
  {
    zipcode: '07983',
    market: 'New York City',
  },
  {
    zipcode: '06497',
    market: 'New York City',
  },
  {
    zipcode: '07202',
    market: 'New York City',
  },
  {
    zipcode: '07401',
    market: 'New York City',
  },
  {
    zipcode: '07503',
    market: 'New York City',
  },
  {
    zipcode: '07843',
    market: 'New York City',
  },
  {
    zipcode: '07850',
    market: 'New York City',
  },
  {
    zipcode: 11757,
    market: 'New York City',
  },
  {
    zipcode: 10020,
    market: 'New York City',
  },
  {
    zipcode: 10115,
    market: 'New York City',
  },
  {
    zipcode: 10130,
    market: 'New York City',
  },
  {
    zipcode: 10160,
    market: 'New York City',
  },
  {
    zipcode: 10532,
    market: 'New York City',
  },
  {
    zipcode: 10708,
    market: 'New York City',
  },
  {
    zipcode: 10927,
    market: 'New York City',
  },
  {
    zipcode: 11004,
    market: 'New York City',
  },
  {
    zipcode: 11207,
    market: 'New York City',
  },
  {
    zipcode: 11545,
    market: 'New York City',
  },
  {
    zipcode: 11722,
    market: 'New York City',
  },
  {
    zipcode: 10156,
    market: 'New York City',
  },
  {
    zipcode: 10306,
    market: 'New York City',
  },
  {
    zipcode: 10503,
    market: 'New York City',
  },
  {
    zipcode: 10550,
    market: 'New York City',
  },
  {
    zipcode: 10956,
    market: 'New York City',
  },
  {
    zipcode: 10993,
    market: 'New York City',
  },
  {
    zipcode: 11365,
    market: 'New York City',
  },
  {
    zipcode: 11514,
    market: 'New York City',
  },
  {
    zipcode: 10167,
    market: 'New York City',
  },
  {
    zipcode: 10285,
    market: 'New York City',
  },
  {
    zipcode: 10458,
    market: 'New York City',
  },
  {
    zipcode: 10521,
    market: 'New York City',
  },
  {
    zipcode: 11226,
    market: 'New York City',
  },
  {
    zipcode: 11731,
    market: 'New York City',
  },
  {
    zipcode: 11763,
    market: 'New York City',
  },
  {
    zipcode: 10041,
    market: 'New York City',
  },
  {
    zipcode: 10155,
    market: 'New York City',
  },
  {
    zipcode: 10591,
    market: 'New York City',
  },
  {
    zipcode: 11218,
    market: 'New York City',
  },
  {
    zipcode: 11425,
    market: 'New York City',
  },
  {
    zipcode: 11557,
    market: 'New York City',
  },
  {
    zipcode: 11726,
    market: 'New York City',
  },
  {
    zipcode: 11804,
    market: 'New York City',
  },
  {
    zipcode: '07474',
    market: 'New York City',
  },
  {
    zipcode: '07821',
    market: 'New York City',
  },
  {
    zipcode: '07846',
    market: 'New York City',
  },
  {
    zipcode: '07860',
    market: 'New York City',
  },
  {
    zipcode: '08933',
    market: 'New York City',
  },
  {
    zipcode: 10039,
    market: 'New York City',
  },
  {
    zipcode: 10122,
    market: 'New York City',
  },
  {
    zipcode: 10594,
    market: 'New York City',
  },
  {
    zipcode: 10970,
    market: 'New York City',
  },
  {
    zipcode: 11223,
    market: 'New York City',
  },
  {
    zipcode: 11575,
    market: 'New York City',
  },
  {
    zipcode: 11738,
    market: 'New York City',
  },
  {
    zipcode: 11777,
    market: 'New York City',
  },
  {
    zipcode: 10138,
    market: 'New York City',
  },
  {
    zipcode: 10280,
    market: 'New York City',
  },
  {
    zipcode: 10931,
    market: 'New York City',
  },
  {
    zipcode: 11096,
    market: 'New York City',
  },
  {
    zipcode: 11256,
    market: 'New York City',
  },
  {
    zipcode: 11381,
    market: 'New York City',
  },
  {
    zipcode: 11554,
    market: 'New York City',
  },
  {
    zipcode: 11732,
    market: 'New York City',
  },
  {
    zipcode: 11764,
    market: 'New York City',
  },
  {
    zipcode: 10151,
    market: 'New York City',
  },
  {
    zipcode: 10260,
    market: 'New York City',
  },
  {
    zipcode: 10703,
    market: 'New York City',
  },
  {
    zipcode: 10954,
    market: 'New York City',
  },
  {
    zipcode: 11206,
    market: 'New York City',
  },
  {
    zipcode: 11417,
    market: 'New York City',
  },
  {
    zipcode: 11549,
    market: 'New York City',
  },
  {
    zipcode: 11590,
    market: 'New York City',
  },
  {
    zipcode: 10030,
    market: 'New York City',
  },
  {
    zipcode: 10080,
    market: 'New York City',
  },
  {
    zipcode: 10110,
    market: 'New York City',
  },
  {
    zipcode: 10606,
    market: 'New York City',
  },
  {
    zipcode: 11051,
    market: 'New York City',
  },
  {
    zipcode: 11231,
    market: 'New York City',
  },
  {
    zipcode: 11413,
    market: 'New York City',
  },
  {
    zipcode: 11542,
    market: 'New York City',
  },
  {
    zipcode: 11717,
    market: 'New York City',
  },
  {
    zipcode: 11747,
    market: 'New York City',
  },
  {
    zipcode: '06913',
    market: 'New York City',
  },
  {
    zipcode: '07175',
    market: 'New York City',
  },
  {
    zipcode: '00501',
    market: 'New York City',
  },
  {
    zipcode: '07855',
    market: 'New York City',
  },
  {
    zipcode: '08906',
    market: 'New York City',
  },
  {
    zipcode: '00401',
    market: 'New York City',
  },
  {
    zipcode: '06610',
    market: 'New York City',
  },
  {
    zipcode: '07090',
    market: 'New York City',
  },
  {
    zipcode: '07193',
    market: 'New York City',
  },
  {
    zipcode: '07309',
    market: 'New York City',
  },
  {
    zipcode: '07457',
    market: 'New York City',
  },
  {
    zipcode: '07506',
    market: 'New York City',
  },
  {
    zipcode: '07010',
    market: 'New York City',
  },
  {
    zipcode: '07079',
    market: 'New York City',
  },
  {
    zipcode: '07110',
    market: 'New York City',
  },
  {
    zipcode: '07208',
    market: 'New York City',
  },
  {
    zipcode: '07461',
    market: 'New York City',
  },
  {
    zipcode: '07822',
    market: 'New York City',
  },
  {
    zipcode: '07938',
    market: 'New York City',
  },
  {
    zipcode: '08846',
    market: 'New York City',
  },
  {
    zipcode: '06903',
    market: 'New York City',
  },
  {
    zipcode: '07001',
    market: 'New York City',
  },
  {
    zipcode: '07011',
    market: 'New York City',
  },
  {
    zipcode: '07052',
    market: 'New York City',
  },
  {
    zipcode: '06854',
    market: 'New York City',
  },
  {
    zipcode: '07007',
    market: 'New York City',
  },
  {
    zipcode: '07024',
    market: 'New York City',
  },
  {
    zipcode: '07435',
    market: 'New York City',
  },
  {
    zipcode: '07495',
    market: 'New York City',
  },
  {
    zipcode: '07508',
    market: 'New York City',
  },
  {
    zipcode: '07626',
    market: 'New York City',
  },
  {
    zipcode: '07660',
    market: 'New York City',
  },
  {
    zipcode: '07869',
    market: 'New York City',
  },
  {
    zipcode: '07885',
    market: 'New York City',
  },
  {
    zipcode: '08821',
    market: 'New York City',
  },
  {
    zipcode: '08887',
    market: 'New York City',
  },
  {
    zipcode: '07073',
    market: 'New York City',
  },
  {
    zipcode: '07104',
    market: 'New York City',
  },
  {
    zipcode: '07410',
    market: 'New York City',
  },
  {
    zipcode: '07480',
    market: 'New York City',
  },
  {
    zipcode: '07505',
    market: 'New York City',
  },
  {
    zipcode: '07604',
    market: 'New York City',
  },
  {
    zipcode: '07924',
    market: 'New York City',
  },
  {
    zipcode: '07962',
    market: 'New York City',
  },
  {
    zipcode: '08502',
    market: 'New York City',
  },
  {
    zipcode: '08885',
    market: 'New York City',
  },
  {
    zipcode: '08888',
    market: 'New York City',
  },
  {
    zipcode: '08922',
    market: 'New York City',
  },
  {
    zipcode: 11778,
    market: 'New York City',
  },
  {
    zipcode: 10003,
    market: 'New York City',
  },
  {
    zipcode: 10019,
    market: 'New York City',
  },
  {
    zipcode: 10174,
    market: 'New York City',
  },
  {
    zipcode: 10271,
    market: 'New York City',
  },
  {
    zipcode: 11050,
    market: 'New York City',
  },
  {
    zipcode: 11209,
    market: 'New York City',
  },
  {
    zipcode: 11355,
    market: 'New York City',
  },
  {
    zipcode: 11428,
    market: 'New York City',
  },
  {
    zipcode: 11531,
    market: 'New York City',
  },
  {
    zipcode: 11784,
    market: 'New York City',
  },
  {
    zipcode: 11973,
    market: 'New York City',
  },
  {
    zipcode: 10014,
    market: 'New York City',
  },
  {
    zipcode: 10037,
    market: 'New York City',
  },
  {
    zipcode: 10570,
    market: 'New York City',
  },
  {
    zipcode: 10706,
    market: 'New York City',
  },
  {
    zipcode: 11566,
    market: 'New York City',
  },
  {
    zipcode: 11740,
    market: 'New York City',
  },
  {
    zipcode: 11775,
    market: 'New York City',
  },
  {
    zipcode: 10075,
    market: 'New York City',
  },
  {
    zipcode: 10109,
    market: 'New York City',
  },
  {
    zipcode: 10211,
    market: 'New York City',
  },
  {
    zipcode: 10504,
    market: 'New York City',
  },
  {
    zipcode: 10533,
    market: 'New York City',
  },
  {
    zipcode: 11053,
    market: 'New York City',
  },
  {
    zipcode: 11233,
    market: 'New York City',
  },
  {
    zipcode: 11362,
    market: 'New York City',
  },
  {
    zipcode: 10013,
    market: 'New York City',
  },
  {
    zipcode: 10314,
    market: 'New York City',
  },
  {
    zipcode: 10538,
    market: 'New York City',
  },
  {
    zipcode: 10583,
    market: 'New York City',
  },
  {
    zipcode: 10913,
    market: 'New York City',
  },
  {
    zipcode: 11020,
    market: 'New York City',
  },
  {
    zipcode: 11249,
    market: 'New York City',
  },
  {
    zipcode: 11366,
    market: 'New York City',
  },
  {
    zipcode: 11415,
    market: 'New York City',
  },
  {
    zipcode: 11729,
    market: 'New York City',
  },
  {
    zipcode: 11783,
    market: 'New York City',
  },
  {
    zipcode: 11796,
    market: 'New York City',
  },
  {
    zipcode: '06911',
    market: 'New York City',
  },
  {
    zipcode: '06853',
    market: 'New York City',
  },
  {
    zipcode: '07303',
    market: 'New York City',
  },
  {
    zipcode: '07828',
    market: 'New York City',
  },
  {
    zipcode: '07630',
    market: 'New York City',
  },
  {
    zipcode: '06601',
    market: 'New York City',
  },
  {
    zipcode: '06699',
    market: 'New York City',
  },
  {
    zipcode: '06883',
    market: 'New York City',
  },
  {
    zipcode: '07029',
    market: 'New York City',
  },
  {
    zipcode: '07044',
    market: 'New York City',
  },
  {
    zipcode: '07064',
    market: 'New York City',
  },
  {
    zipcode: '07935',
    market: 'New York City',
  },
  {
    zipcode: '07976',
    market: 'New York City',
  },
  {
    zipcode: '07932',
    market: 'New York City',
  },
  {
    zipcode: '07876',
    market: 'New York City',
  },
  {
    zipcode: '06902',
    market: 'New York City',
  },
  {
    zipcode: '07098',
    market: 'New York City',
  },
  {
    zipcode: '07432',
    market: 'New York City',
  },
  {
    zipcode: '07458',
    market: 'New York City',
  },
  {
    zipcode: '07530',
    market: 'New York City',
  },
  {
    zipcode: '07880',
    market: 'New York City',
  },
  {
    zipcode: '07950',
    market: 'New York City',
  },
  {
    zipcode: '08805',
    market: 'New York City',
  },
  {
    zipcode: '06404',
    market: 'New York City',
  },
  {
    zipcode: '06432',
    market: 'New York City',
  },
  {
    zipcode: '06901',
    market: 'New York City',
  },
  {
    zipcode: '07047',
    market: 'New York City',
  },
  {
    zipcode: '07095',
    market: 'New York City',
  },
  {
    zipcode: '07456',
    market: 'New York City',
  },
  {
    zipcode: '07670',
    market: 'New York City',
  },
  {
    zipcode: 10024,
    market: 'New York City',
  },
  {
    zipcode: 10055,
    market: 'New York City',
  },
  {
    zipcode: 10164,
    market: 'New York City',
  },
  {
    zipcode: 10507,
    market: 'New York City',
  },
  {
    zipcode: 11042,
    market: 'New York City',
  },
  {
    zipcode: 11418,
    market: 'New York City',
  },
  {
    zipcode: 11558,
    market: 'New York City',
  },
  {
    zipcode: 11596,
    market: 'New York City',
  },
  {
    zipcode: 11754,
    market: 'New York City',
  },
  {
    zipcode: 11787,
    market: 'New York City',
  },
  {
    zipcode: 11934,
    market: 'New York City',
  },
  {
    zipcode: 10108,
    market: 'New York City',
  },
  {
    zipcode: 10261,
    market: 'New York City',
  },
  {
    zipcode: 10980,
    market: 'New York City',
  },
  {
    zipcode: 11352,
    market: 'New York City',
  },
  {
    zipcode: 11580,
    market: 'New York City',
  },
  {
    zipcode: 11707,
    market: 'New York City',
  },
  {
    zipcode: 11782,
    market: 'New York City',
  },
  {
    zipcode: 11815,
    market: 'New York City',
  },
  {
    zipcode: 11950,
    market: 'New York City',
  },
  {
    zipcode: 10121,
    market: 'New York City',
  },
  {
    zipcode: 10175,
    market: 'New York City',
  },
  {
    zipcode: 10269,
    market: 'New York City',
  },
  {
    zipcode: 11040,
    market: 'New York City',
  },
  {
    zipcode: 11360,
    market: 'New York City',
  },
  {
    zipcode: 11579,
    market: 'New York City',
  },
  {
    zipcode: 11737,
    market: 'New York City',
  },
  {
    zipcode: 11776,
    market: 'New York City',
  },
  {
    zipcode: 10256,
    market: 'New York City',
  },
  {
    zipcode: 10470,
    market: 'New York City',
  },
  {
    zipcode: 10549,
    market: 'New York City',
  },
  {
    zipcode: 11109,
    market: 'New York City',
  },
  {
    zipcode: 11713,
    market: 'New York City',
  },
  {
    zipcode: 11771,
    market: 'New York City',
  },
  {
    zipcode: 11953,
    market: 'New York City',
  },
  {
    zipcode: '06914',
    market: 'New York City',
  },
  {
    zipcode: 10033,
    market: 'New York City',
  },
  {
    zipcode: 10132,
    market: 'New York City',
  },
  {
    zipcode: 10979,
    market: 'New York City',
  },
  {
    zipcode: 11205,
    market: 'New York City',
  },
  {
    zipcode: 11230,
    market: 'New York City',
  },
  {
    zipcode: 11416,
    market: 'New York City',
  },
  {
    zipcode: 11582,
    market: 'New York City',
  },
  {
    zipcode: 10124,
    market: 'New York City',
  },
  {
    zipcode: 10469,
    market: 'New York City',
  },
  {
    zipcode: 10510,
    market: 'New York City',
  },
  {
    zipcode: 10925,
    market: 'New York City',
  },
  {
    zipcode: 11412,
    market: 'New York City',
  },
  {
    zipcode: 11499,
    market: 'New York City',
  },
  {
    zipcode: 11577,
    market: 'New York City',
  },
  {
    zipcode: 11766,
    market: 'New York City',
  },
  {
    zipcode: 10018,
    market: 'New York City',
  },
  {
    zipcode: 10032,
    market: 'New York City',
  },
  {
    zipcode: 10116,
    market: 'New York City',
  },
  {
    zipcode: 10169,
    market: 'New York City',
  },
  {
    zipcode: 10278,
    market: 'New York City',
  },
  {
    zipcode: 10551,
    market: 'New York City',
  },
  {
    zipcode: 10131,
    market: 'New York City',
  },
  {
    zipcode: 10165,
    market: 'New York City',
  },
  {
    zipcode: 10310,
    market: 'New York City',
  },
  {
    zipcode: 10468,
    market: 'New York City',
  },
  {
    zipcode: 10595,
    market: 'New York City',
  },
  {
    zipcode: 10709,
    market: 'New York City',
  },
  {
    zipcode: 10901,
    market: 'New York City',
  },
  {
    zipcode: 11229,
    market: 'New York City',
  },
  {
    zipcode: 11374,
    market: 'New York City',
  },
  {
    zipcode: 11559,
    market: 'New York City',
  },
  {
    zipcode: 11354,
    market: 'New York City',
  },
  {
    zipcode: 11427,
    market: 'New York City',
  },
  {
    zipcode: 11555,
    market: 'New York City',
  },
  {
    zipcode: 11598,
    market: 'New York City',
  },
  {
    zipcode: '07013',
    market: 'New York City',
  },
  {
    zipcode: '07407',
    market: 'New York City',
  },
  {
    zipcode: '07440',
    market: 'New York City',
  },
  {
    zipcode: '07834',
    market: 'New York City',
  },
  {
    zipcode: '07853',
    market: 'New York City',
  },
  {
    zipcode: '06856',
    market: 'New York City',
  },
  {
    zipcode: '06608',
    market: 'New York City',
  },
  {
    zipcode: '07008',
    market: 'New York City',
  },
  {
    zipcode: '07642',
    market: 'New York City',
  },
  {
    zipcode: '07656',
    market: 'New York City',
  },
  {
    zipcode: '07628',
    market: 'New York City',
  },
  {
    zipcode: '07879',
    market: 'New York City',
  },
  {
    zipcode: '08551',
    market: 'New York City',
  },
  {
    zipcode: '07926',
    market: 'New York City',
  },
  {
    zipcode: '07070',
    market: 'New York City',
  },
  {
    zipcode: '07096',
    market: 'New York City',
  },
  {
    zipcode: '07191',
    market: 'New York City',
  },
  {
    zipcode: '07203',
    market: 'New York City',
  },
  {
    zipcode: '07304',
    market: 'New York City',
  },
  {
    zipcode: '07420',
    market: 'New York City',
  },
  {
    zipcode: '07465',
    market: 'New York City',
  },
  {
    zipcode: '06840',
    market: 'New York City',
  },
  {
    zipcode: '07028',
    market: 'New York City',
  },
  {
    zipcode: '07091',
    market: 'New York City',
  },
  {
    zipcode: '07215',
    market: 'New York City',
  },
  {
    zipcode: '07452',
    market: 'New York City',
  },
  {
    zipcode: '07647',
    market: 'New York City',
  },
  {
    zipcode: '08853',
    market: 'New York City',
  },
  {
    zipcode: '08901',
    market: 'New York City',
  },
  {
    zipcode: 10273,
    market: 'New York City',
  },
  {
    zipcode: 10451,
    market: 'New York City',
  },
  {
    zipcode: 10960,
    market: 'New York City',
  },
  {
    zipcode: 11247,
    market: 'New York City',
  },
  {
    zipcode: 11378,
    market: 'New York City',
  },
  {
    zipcode: 11426,
    market: 'New York City',
  },
  {
    zipcode: 10017,
    market: 'New York City',
  },
  {
    zipcode: 10111,
    market: 'New York City',
  },
  {
    zipcode: 10126,
    market: 'New York City',
  },
  {
    zipcode: 10185,
    market: 'New York City',
  },
  {
    zipcode: 11203,
    market: 'New York City',
  },
  {
    zipcode: 11228,
    market: 'New York City',
  },
  {
    zipcode: 11422,
    market: 'New York City',
  },
  {
    zipcode: 11695,
    market: 'New York City',
  },
  {
    zipcode: 11749,
    market: 'New York City',
  },
  {
    zipcode: 11795,
    market: 'New York City',
  },
  {
    zipcode: 10008,
    market: 'New York City',
  },
  {
    zipcode: 10069,
    market: 'New York City',
  },
  {
    zipcode: 10107,
    market: 'New York City',
  },
  {
    zipcode: 10805,
    market: 'New York City',
  },
  {
    zipcode: 11003,
    market: 'New York City',
  },
  {
    zipcode: 11380,
    market: 'New York City',
  },
  {
    zipcode: 11510,
    market: 'New York City',
  },
  {
    zipcode: 11568,
    market: 'New York City',
  },
  {
    zipcode: 11694,
    market: 'New York City',
  },
  {
    zipcode: 10103,
    market: 'New York City',
  },
  {
    zipcode: 10125,
    market: 'New York City',
  },
  {
    zipcode: 10276,
    market: 'New York City',
  },
  {
    zipcode: 10309,
    market: 'New York City',
  },
  {
    zipcode: 10707,
    market: 'New York City',
  },
  {
    zipcode: 10987,
    market: 'New York City',
  },
  {
    zipcode: 11356,
    market: 'New York City',
  },
  {
    zipcode: 11690,
    market: 'New York City',
  },
  {
    zipcode: '06881',
    market: 'New York City',
  },
  {
    zipcode: 94024,
    market: 'San Francisco',
  },
  {
    zipcode: 94304,
    market: 'San Francisco',
  },
  {
    zipcode: 94536,
    market: 'San Francisco',
  },
  {
    zipcode: 94130,
    market: 'San Francisco',
  },
  {
    zipcode: 94510,
    market: 'San Francisco',
  },
  {
    zipcode: 94808,
    market: 'San Francisco',
  },
  {
    zipcode: 95054,
    market: 'San Francisco',
  },
  {
    zipcode: 95103,
    market: 'San Francisco',
  },
  {
    zipcode: 95132,
    market: 'San Francisco',
  },
  {
    zipcode: 95202,
    market: 'San Francisco',
  },
  {
    zipcode: 95269,
    market: 'San Francisco',
  },
  {
    zipcode: 94545,
    market: 'San Francisco',
  },
  {
    zipcode: 94561,
    market: 'San Francisco',
  },
  {
    zipcode: 94586,
    market: 'San Francisco',
  },
  {
    zipcode: 94703,
    market: 'San Francisco',
  },
  {
    zipcode: 94805,
    market: 'San Francisco',
  },
  {
    zipcode: 95367,
    market: 'San Francisco',
  },
  {
    zipcode: 95641,
    market: 'San Francisco',
  },
  {
    zipcode: 94043,
    market: 'San Francisco',
  },
  {
    zipcode: 94622,
    market: 'San Francisco',
  },
  {
    zipcode: 94039,
    market: 'San Francisco',
  },
  {
    zipcode: 94589,
    market: 'San Francisco',
  },
  {
    zipcode: 95231,
    market: 'San Francisco',
  },
  {
    zipcode: 94040,
    market: 'San Francisco',
  },
  {
    zipcode: 94177,
    market: 'San Francisco',
  },
  {
    zipcode: 94404,
    market: 'San Francisco',
  },
  {
    zipcode: 94915,
    market: 'San Francisco',
  },
  {
    zipcode: 94978,
    market: 'San Francisco',
  },
  {
    zipcode: 95316,
    market: 'San Francisco',
  },
  {
    zipcode: 95357,
    market: 'San Francisco',
  },
  {
    zipcode: 94088,
    market: 'San Francisco',
  },
  {
    zipcode: 94161,
    market: 'San Francisco',
  },
  {
    zipcode: 94904,
    market: 'San Francisco',
  },
  {
    zipcode: 95237,
    market: 'San Francisco',
  },
  {
    zipcode: 94102,
    market: 'San Francisco',
  },
  {
    zipcode: 94583,
    market: 'San Francisco',
  },
  {
    zipcode: 94110,
    market: 'San Francisco',
  },
  {
    zipcode: 94627,
    market: 'San Francisco',
  },
  {
    zipcode: 95102,
    market: 'San Francisco',
  },
  {
    zipcode: 95215,
    market: 'San Francisco',
  },
  {
    zipcode: 95397,
    market: 'San Francisco',
  },
  {
    zipcode: 94930,
    market: 'San Francisco',
  },
  {
    zipcode: 95051,
    market: 'San Francisco',
  },
  {
    zipcode: 95114,
    market: 'San Francisco',
  },
  {
    zipcode: 95134,
    market: 'San Francisco',
  },
  {
    zipcode: 94105,
    market: 'San Francisco',
  },
  {
    zipcode: 94120,
    market: 'San Francisco',
  },
  {
    zipcode: 95230,
    market: 'San Francisco',
  },
  {
    zipcode: 94188,
    market: 'San Francisco',
  },
  {
    zipcode: 94913,
    market: 'San Francisco',
  },
  {
    zipcode: 94521,
    market: 'San Francisco',
  },
  {
    zipcode: 94552,
    market: 'San Francisco',
  },
  {
    zipcode: 94109,
    market: 'San Francisco',
  },
  {
    zipcode: 94514,
    market: 'San Francisco',
  },
  {
    zipcode: 94527,
    market: 'San Francisco',
  },
  {
    zipcode: 94549,
    market: 'San Francisco',
  },
  {
    zipcode: 94661,
    market: 'San Francisco',
  },
  {
    zipcode: 94709,
    market: 'San Francisco',
  },
  {
    zipcode: 94820,
    market: 'San Francisco',
  },
  {
    zipcode: 95035,
    market: 'San Francisco',
  },
  {
    zipcode: 95172,
    market: 'San Francisco',
  },
  {
    zipcode: 95353,
    market: 'San Francisco',
  },
  {
    zipcode: 95384,
    market: 'San Francisco',
  },
  {
    zipcode: 94577,
    market: 'San Francisco',
  },
  {
    zipcode: 94605,
    market: 'San Francisco',
  },
  {
    zipcode: 94649,
    market: 'San Francisco',
  },
  {
    zipcode: 94708,
    market: 'San Francisco',
  },
  {
    zipcode: 94806,
    market: 'San Francisco',
  },
  {
    zipcode: 95115,
    market: 'San Francisco',
  },
  {
    zipcode: 95135,
    market: 'San Francisco',
  },
  {
    zipcode: 95164,
    market: 'San Francisco',
  },
  {
    zipcode: 95204,
    market: 'San Francisco',
  },
  {
    zipcode: 95212,
    market: 'San Francisco',
  },
  {
    zipcode: 95376,
    market: 'San Francisco',
  },
  {
    zipcode: 94103,
    market: 'San Francisco',
  },
  {
    zipcode: 94144,
    market: 'San Francisco',
  },
  {
    zipcode: 94572,
    market: 'San Francisco',
  },
  {
    zipcode: 95258,
    market: 'San Francisco',
  },
  {
    zipcode: 94507,
    market: 'San Francisco',
  },
  {
    zipcode: 94151,
    market: 'San Francisco',
  },
  {
    zipcode: 94528,
    market: 'San Francisco',
  },
  {
    zipcode: 94035,
    market: 'San Francisco',
  },
  {
    zipcode: 94141,
    market: 'San Francisco',
  },
  {
    zipcode: 94309,
    market: 'San Francisco',
  },
  {
    zipcode: 94070,
    market: 'San Francisco',
  },
  {
    zipcode: 94401,
    market: 'San Francisco',
  },
  {
    zipcode: 94538,
    market: 'San Francisco',
  },
  {
    zipcode: 94570,
    market: 'San Francisco',
  },
  {
    zipcode: 94612,
    market: 'San Francisco',
  },
  {
    zipcode: 94660,
    market: 'San Francisco',
  },
  {
    zipcode: 95121,
    market: 'San Francisco',
  },
  {
    zipcode: 95241,
    market: 'San Francisco',
  },
  {
    zipcode: 95133,
    market: 'San Francisco',
  },
  {
    zipcode: 95252,
    market: 'San Francisco',
  },
  {
    zipcode: 95214,
    market: 'San Francisco',
  },
  {
    zipcode: 94146,
    market: 'San Francisco',
  },
  {
    zipcode: 94624,
    market: 'San Francisco',
  },
  {
    zipcode: 94850,
    market: 'San Francisco',
  },
  {
    zipcode: 94522,
    market: 'San Francisco',
  },
  {
    zipcode: 94061,
    market: 'San Francisco',
  },
  {
    zipcode: 94541,
    market: 'San Francisco',
  },
  {
    zipcode: 94566,
    market: 'San Francisco',
  },
  {
    zipcode: 94306,
    market: 'San Francisco',
  },
  {
    zipcode: 94539,
    market: 'San Francisco',
  },
  {
    zipcode: 94597,
    market: 'San Francisco',
  },
  {
    zipcode: 94643,
    market: 'San Francisco',
  },
  {
    zipcode: 95112,
    market: 'San Francisco',
  },
  {
    zipcode: 94706,
    market: 'San Francisco',
  },
  {
    zipcode: 95108,
    market: 'San Francisco',
  },
  {
    zipcode: 95137,
    market: 'San Francisco',
  },
  {
    zipcode: 95236,
    market: 'San Francisco',
  },
  {
    zipcode: 95355,
    market: 'San Francisco',
  },
  {
    zipcode: 94903,
    market: 'San Francisco',
  },
  {
    zipcode: 95131,
    market: 'San Francisco',
  },
  {
    zipcode: 94025,
    market: 'San Francisco',
  },
  {
    zipcode: 94302,
    market: 'San Francisco',
  },
  {
    zipcode: 94145,
    market: 'San Francisco',
  },
  {
    zipcode: 94520,
    market: 'San Francisco',
  },
  {
    zipcode: 94595,
    market: 'San Francisco',
  },
  {
    zipcode: 95116,
    market: 'San Francisco',
  },
  {
    zipcode: 95328,
    market: 'San Francisco',
  },
  {
    zipcode: 94553,
    market: 'San Francisco',
  },
  {
    zipcode: 95106,
    market: 'San Francisco',
  },
  {
    zipcode: 95128,
    market: 'San Francisco',
  },
  {
    zipcode: 95267,
    market: 'San Francisco',
  },
  {
    zipcode: 95320,
    market: 'San Francisco',
  },
  {
    zipcode: 94041,
    market: 'San Francisco',
  },
  {
    zipcode: 94089,
    market: 'San Francisco',
  },
  {
    zipcode: 94513,
    market: 'San Francisco',
  },
  {
    zipcode: 94547,
    market: 'San Francisco',
  },
  {
    zipcode: 94601,
    market: 'San Francisco',
  },
  {
    zipcode: 94620,
    market: 'San Francisco',
  },
  {
    zipcode: 95122,
    market: 'San Francisco',
  },
  {
    zipcode: 95203,
    market: 'San Francisco',
  },
  {
    zipcode: 95354,
    market: 'San Francisco',
  },
  {
    zipcode: 94662,
    market: 'San Francisco',
  },
  {
    zipcode: 94960,
    market: 'San Francisco',
  },
  {
    zipcode: 95055,
    market: 'San Francisco',
  },
  {
    zipcode: 95194,
    market: 'San Francisco',
  },
  {
    zipcode: 95290,
    market: 'San Francisco',
  },
  {
    zipcode: 95387,
    market: 'San Francisco',
  },
  {
    zipcode: 94147,
    market: 'San Francisco',
  },
  {
    zipcode: 94042,
    market: 'San Francisco',
  },
  {
    zipcode: 94305,
    market: 'San Francisco',
  },
  {
    zipcode: 94512,
    market: 'San Francisco',
  },
  {
    zipcode: 94523,
    market: 'San Francisco',
  },
  {
    zipcode: 94543,
    market: 'San Francisco',
  },
  {
    zipcode: 94911,
    market: 'San Francisco',
  },
  {
    zipcode: 95129,
    market: 'San Francisco',
  },
  {
    zipcode: 95157,
    market: 'San Francisco',
  },
  {
    zipcode: 95210,
    market: 'San Francisco',
  },
  {
    zipcode: 95242,
    market: 'San Francisco',
  },
  {
    zipcode: 95337,
    market: 'San Francisco',
  },
  {
    zipcode: 94509,
    market: 'San Francisco',
  },
  {
    zipcode: 94557,
    market: 'San Francisco',
  },
  {
    zipcode: 94568,
    market: 'San Francisco',
  },
  {
    zipcode: 94582,
    market: 'San Francisco',
  },
  {
    zipcode: 94901,
    market: 'San Francisco',
  },
  {
    zipcode: 95002,
    market: 'San Francisco',
  },
  {
    zipcode: 95036,
    market: 'San Francisco',
  },
  {
    zipcode: 95207,
    market: 'San Francisco',
  },
  {
    zipcode: 95319,
    market: 'San Francisco',
  },
  {
    zipcode: 95356,
    market: 'San Francisco',
  },
  {
    zipcode: 94065,
    market: 'San Francisco',
  },
  {
    zipcode: 95196,
    market: 'San Francisco',
  },
  {
    zipcode: 94160,
    market: 'San Francisco',
  },
  {
    zipcode: 94610,
    market: 'San Francisco',
  },
  {
    zipcode: 94303,
    market: 'San Francisco',
  },
  {
    zipcode: 95192,
    market: 'San Francisco',
  },
  {
    zipcode: 94022,
    market: 'San Francisco',
  },
  {
    zipcode: 94104,
    market: 'San Francisco',
  },
  {
    zipcode: 94565,
    market: 'San Francisco',
  },
  {
    zipcode: 94998,
    market: 'San Francisco',
  },
  {
    zipcode: 94546,
    market: 'San Francisco',
  },
  {
    zipcode: 94028,
    market: 'San Francisco',
  },
  {
    zipcode: 94551,
    market: 'San Francisco',
  },
  {
    zipcode: 94571,
    market: 'San Francisco',
  },
  {
    zipcode: 95326,
    market: 'San Francisco',
  },
  {
    zipcode: 95113,
    market: 'San Francisco',
  },
  {
    zipcode: 95307,
    market: 'San Francisco',
  },
  {
    zipcode: 94979,
    market: 'San Francisco',
  },
  {
    zipcode: 94137,
    market: 'San Francisco',
  },
  {
    zipcode: 94108,
    market: 'San Francisco',
  },
  {
    zipcode: 94403,
    market: 'San Francisco',
  },
  {
    zipcode: 94524,
    market: 'San Francisco',
  },
  {
    zipcode: 94550,
    market: 'San Francisco',
  },
  {
    zipcode: 94062,
    market: 'San Francisco',
  },
  {
    zipcode: 94107,
    market: 'San Francisco',
  },
  {
    zipcode: 94301,
    market: 'San Francisco',
  },
  {
    zipcode: 94575,
    market: 'San Francisco',
  },
  {
    zipcode: 94588,
    market: 'San Francisco',
  },
  {
    zipcode: 94615,
    market: 'San Francisco',
  },
  {
    zipcode: 94619,
    market: 'San Francisco',
  },
  {
    zipcode: 94705,
    market: 'San Francisco',
  },
  {
    zipcode: 94947,
    market: 'San Francisco',
  },
  {
    zipcode: 95390,
    market: 'San Francisco',
  },
  {
    zipcode: 94569,
    market: 'San Francisco',
  },
  {
    zipcode: 94604,
    market: 'San Francisco',
  },
  {
    zipcode: 94618,
    market: 'San Francisco',
  },
  {
    zipcode: 95014,
    market: 'San Francisco',
  },
  {
    zipcode: 95052,
    market: 'San Francisco',
  },
  {
    zipcode: 95130,
    market: 'San Francisco',
  },
  {
    zipcode: 94125,
    market: 'San Francisco',
  },
  {
    zipcode: 94531,
    market: 'San Francisco',
  },
  {
    zipcode: 94720,
    market: 'San Francisco',
  },
  {
    zipcode: 94948,
    market: 'San Francisco',
  },
  {
    zipcode: 95155,
    market: 'San Francisco',
  },
  {
    zipcode: 94519,
    market: 'San Francisco',
  },
  {
    zipcode: 94702,
    market: 'San Francisco',
  },
  {
    zipcode: 95110,
    market: 'San Francisco',
  },
  {
    zipcode: 95151,
    market: 'San Francisco',
  },
  {
    zipcode: 95050,
    market: 'San Francisco',
  },
  {
    zipcode: 94611,
    market: 'San Francisco',
  },
  {
    zipcode: 94974,
    market: 'San Francisco',
  },
  {
    zipcode: 94086,
    market: 'San Francisco',
  },
  {
    zipcode: 94111,
    market: 'San Francisco',
  },
  {
    zipcode: 94542,
    market: 'San Francisco',
  },
  {
    zipcode: 94579,
    market: 'San Francisco',
  },
  {
    zipcode: 94606,
    market: 'San Francisco',
  },
  {
    zipcode: 94803,
    market: 'San Francisco',
  },
  {
    zipcode: 95125,
    market: 'San Francisco',
  },
  {
    zipcode: 95173,
    market: 'San Francisco',
  },
  {
    zipcode: 95240,
    market: 'San Francisco',
  },
  {
    zipcode: 95304,
    market: 'San Francisco',
  },
  {
    zipcode: 94613,
    market: 'San Francisco',
  },
  {
    zipcode: 94659,
    market: 'San Francisco',
  },
  {
    zipcode: 94807,
    market: 'San Francisco',
  },
  {
    zipcode: 95190,
    market: 'San Francisco',
  },
  {
    zipcode: 95336,
    market: 'San Francisco',
  },
  {
    zipcode: 94712,
    market: 'San Francisco',
  },
  {
    zipcode: 94912,
    market: 'San Francisco',
  },
  {
    zipcode: 94159,
    market: 'San Francisco',
  },
  {
    zipcode: 94506,
    market: 'San Francisco',
  },
  {
    zipcode: 94537,
    market: 'San Francisco',
  },
  {
    zipcode: 94134,
    market: 'San Francisco',
  },
  {
    zipcode: 94199,
    market: 'San Francisco',
  },
  {
    zipcode: 94402,
    market: 'San Francisco',
  },
  {
    zipcode: 94505,
    market: 'San Francisco',
  },
  {
    zipcode: 94518,
    market: 'San Francisco',
  },
  {
    zipcode: 94560,
    market: 'San Francisco',
  },
  {
    zipcode: 94564,
    market: 'San Francisco',
  },
  {
    zipcode: 94580,
    market: 'San Francisco',
  },
  {
    zipcode: 94591,
    market: 'San Francisco',
  },
  {
    zipcode: 94607,
    market: 'San Francisco',
  },
  {
    zipcode: 95152,
    market: 'San Francisco',
  },
  {
    zipcode: 95159,
    market: 'San Francisco',
  },
  {
    zipcode: 95206,
    market: 'San Francisco',
  },
  {
    zipcode: 95213,
    market: 'San Francisco',
  },
  {
    zipcode: 95297,
    market: 'San Francisco',
  },
  {
    zipcode: 95377,
    market: 'San Francisco',
  },
  {
    zipcode: 94590,
    market: 'San Francisco',
  },
  {
    zipcode: 95352,
    market: 'San Francisco',
  },
  {
    zipcode: 94603,
    market: 'San Francisco',
  },
  {
    zipcode: 95053,
    market: 'San Francisco',
  },
  {
    zipcode: 95170,
    market: 'San Francisco',
  },
  {
    zipcode: 95366,
    market: 'San Francisco',
  },
  {
    zipcode: 94598,
    market: 'San Francisco',
  },
  {
    zipcode: 94939,
    market: 'San Francisco',
  },
  {
    zipcode: 95140,
    market: 'San Francisco',
  },
  {
    zipcode: 95361,
    market: 'San Francisco',
  },
  {
    zipcode: 94126,
    market: 'San Francisco',
  },
  {
    zipcode: 94623,
    market: 'San Francisco',
  },
  {
    zipcode: 95385,
    market: 'San Francisco',
  },
  {
    zipcode: 94608,
    market: 'San Francisco',
  },
  {
    zipcode: 94964,
    market: 'San Francisco',
  },
  {
    zipcode: 95015,
    market: 'San Francisco',
  },
  {
    zipcode: 95205,
    market: 'San Francisco',
  },
  {
    zipcode: 94158,
    market: 'San Francisco',
  },
  {
    zipcode: 94609,
    market: 'San Francisco',
  },
  {
    zipcode: 94650,
    market: 'San Francisco',
  },
  {
    zipcode: 94802,
    market: 'San Francisco',
  },
  {
    zipcode: 94085,
    market: 'San Francisco',
  },
  {
    zipcode: 95142,
    market: 'San Francisco',
  },
  {
    zipcode: 95378,
    market: 'San Francisco',
  },
  {
    zipcode: 95148,
    market: 'San Francisco',
  },
  {
    zipcode: 95358,
    market: 'San Francisco',
  },
  {
    zipcode: 94666,
    market: 'San Francisco',
  },
  {
    zipcode: 94957,
    market: 'San Francisco',
  },
  {
    zipcode: 95296,
    market: 'San Francisco',
  },
  {
    zipcode: 94124,
    market: 'San Francisco',
  },
  {
    zipcode: 94529,
    market: 'San Francisco',
  },
  {
    zipcode: 94556,
    market: 'San Francisco',
  },
  {
    zipcode: 94005,
    market: 'San Francisco',
  },
  {
    zipcode: 94502,
    market: 'San Francisco',
  },
  {
    zipcode: 94526,
    market: 'San Francisco',
  },
  {
    zipcode: 94617,
    market: 'San Francisco',
  },
  {
    zipcode: 94801,
    market: 'San Francisco',
  },
  {
    zipcode: 94875,
    market: 'San Francisco',
  },
  {
    zipcode: 94945,
    market: 'San Francisco',
  },
  {
    zipcode: 95150,
    market: 'San Francisco',
  },
  {
    zipcode: 94555,
    market: 'San Francisco',
  },
  {
    zipcode: 94563,
    market: 'San Francisco',
  },
  {
    zipcode: 94578,
    market: 'San Francisco',
  },
  {
    zipcode: 94592,
    market: 'San Francisco',
  },
  {
    zipcode: 94616,
    market: 'San Francisco',
  },
  {
    zipcode: 94621,
    market: 'San Francisco',
  },
  {
    zipcode: 95211,
    market: 'San Francisco',
  },
  {
    zipcode: 94140,
    market: 'San Francisco',
  },
  {
    zipcode: 94511,
    market: 'San Francisco',
  },
  {
    zipcode: 94548,
    market: 'San Francisco',
  },
  {
    zipcode: 95219,
    market: 'San Francisco',
  },
  {
    zipcode: 94087,
    market: 'San Francisco',
  },
  {
    zipcode: 94133,
    market: 'San Francisco',
  },
  {
    zipcode: 94544,
    market: 'San Francisco',
  },
  {
    zipcode: 95127,
    market: 'San Francisco',
  },
  {
    zipcode: 95208,
    market: 'San Francisco',
  },
  {
    zipcode: 94002,
    market: 'San Francisco',
  },
  {
    zipcode: 94949,
    market: 'San Francisco',
  },
  {
    zipcode: 95209,
    market: 'San Francisco',
  },
  {
    zipcode: 94530,
    market: 'San Francisco',
  },
  {
    zipcode: 94602,
    market: 'San Francisco',
  },
  {
    zipcode: 94625,
    market: 'San Francisco',
  },
  {
    zipcode: 95234,
    market: 'San Francisco',
  },
  {
    zipcode: 95391,
    market: 'San Francisco',
  },
  {
    zipcode: 95009,
    market: 'San Francisco',
  },
  {
    zipcode: 95117,
    market: 'San Francisco',
  },
  {
    zipcode: 94119,
    market: 'San Francisco',
  },
  {
    zipcode: 94091,
    market: 'San Francisco',
  },
  {
    zipcode: 94501,
    market: 'San Francisco',
  },
  {
    zipcode: 94517,
    market: 'San Francisco',
  },
  {
    zipcode: 94587,
    market: 'San Francisco',
  },
  {
    zipcode: 94707,
    market: 'San Francisco',
  },
  {
    zipcode: 94804,
    market: 'San Francisco',
  },
  {
    zipcode: 95109,
    market: 'San Francisco',
  },
  {
    zipcode: 95161,
    market: 'San Francisco',
  },
  {
    zipcode: 95201,
    market: 'San Francisco',
  },
  {
    zipcode: 95351,
    market: 'San Francisco',
  },
  {
    zipcode: 95368,
    market: 'San Francisco',
  },
  {
    zipcode: 94027,
    market: 'San Francisco',
  },
  {
    zipcode: 94497,
    market: 'San Francisco',
  },
  {
    zipcode: 94516,
    market: 'San Francisco',
  },
  {
    zipcode: 94540,
    market: 'San Francisco',
  },
  {
    zipcode: 94596,
    market: 'San Francisco',
  },
  {
    zipcode: 94710,
    market: 'San Francisco',
  },
  {
    zipcode: 95126,
    market: 'San Francisco',
  },
  {
    zipcode: 95156,
    market: 'San Francisco',
  },
  {
    zipcode: 95253,
    market: 'San Francisco',
  },
  {
    zipcode: 95298,
    market: 'San Francisco',
  },
  {
    zipcode: 95350,
    market: 'San Francisco',
  },
  {
    zipcode: 94172,
    market: 'San Francisco',
  },
  {
    zipcode: 94614,
    market: 'San Francisco',
  },
  {
    zipcode: 94914,
    market: 'San Francisco',
  },
  {
    zipcode: 95191,
    market: 'San Francisco',
  },
  {
    zipcode: 95011,
    market: 'San Francisco',
  },
  {
    zipcode: 95141,
    market: 'San Francisco',
  },
  {
    zipcode: 94063,
    market: 'San Francisco',
  },
  {
    zipcode: 94525,
    market: 'San Francisco',
  },
  {
    zipcode: 94626,
    market: 'San Francisco',
  },
  {
    zipcode: 94701,
    market: 'San Francisco',
  },
  {
    zipcode: 95101,
    market: 'San Francisco',
  },
  {
    zipcode: 95199,
    market: 'San Francisco',
  },
  {
    zipcode: 94704,
    market: 'San Francisco',
  },
  {
    zipcode: 95056,
    market: 'San Francisco',
  },
  {
    zipcode: 95330,
    market: 'San Francisco',
  },
  {
    zipcode: 94023,
    market: 'San Francisco',
  },
  {
    zipcode: 94142,
    market: 'San Francisco',
  },
  {
    zipcode: 94163,
    market: 'San Francisco',
  },
  {
    zipcode: 94139,
    market: 'San Francisco',
  },
  {
    zipcode: 94164,
    market: 'San Francisco',
  },
];
